import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const questionAPI = {
	getQuestions: () => {
		return axios.get(`${apiUrl}/questions`)
		.then(response => response.data);
	},	
};

export default questionAPI;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/questionAPI.ts